import React, { useRef } from 'react'
import CardBody from '../../../src/components/card/CardBody'
import CustomCard from '../../../src/components/card/CustomCard'
import CustomCardHeader from '../../../src/components/card/CustomCardHeader'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState, useCallback } from 'react'
import ProductSearchSelect from 'components/selects/ProductSearchSelect'
import AddFaqForm from './FaqForm'
import CustomButton from 'components/CustomButton'
import ProductCard from 'pages/dynamicUi/elements/products/ProductCard'
import { tryGetFaqById } from 'redux/slices/faqSlice'
import CustomIcon from 'components/CustomIcon'
import { DangerButton } from 'components/CustomButton'
import TextArea from 'components/form/TextArea'
import { SecondaryButton } from 'components/CustomButton'
import ConfirmModal from 'components/ConfirmModal'
import ComponentLoader from 'components/ComponentLoader'
import db, { auth } from '../../db/firebase.js'
import { SemiTransparentButton } from 'components/CustomButton'
import { signOut } from '@firebase/auth'
import { toast } from 'react-toastify'
import TextEditor from 'components/form/textEditor/TextEditor'
import { FIREBASE_COLLECTION, SUB_COLLECTION } from './constant'
import {
  collection,
  doc,
  getDoc,
  onSnapshot,
  updateDoc,
} from '@firebase/firestore'
import EmptyState from 'components/EmptyState'

const ProductFaq = ({ isLogged = false }) => {
  const dispatch = useDispatch()

  const [showModal, setShowModal] = useState(false)
  const [product, setProduct] = useState()
  const [removeModal, setRemoveModal] = useState(false)
  const [isEdit, setEdit] = useState()
  const [expanded, setExpanded] = useState()

  // const { faq, loading, processing } = useSelector((state) => state.faq)
  const [faq, setFaq] = useState({})

  const { loading, processing } = [false, false]

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (!user) {
        setFaq({})
        setProduct()
      }
    })

    // Cleanup the subscription when the component unmounts
    return () => unsubscribe()
  }, [])

  useEffect(() => {
    setEdit()
    setShowModal(false)
    setRemoveModal(false)
  }, [faq])

  // useEffect(() => {
  //   if (product) {
  //     onSnapshot(doc(db, FIREBASE_COLLECTION, product.product_id), (doc) => {
  //       setFaq(doc.data())
  //     })
  //   }
  // }, [product])

  useEffect(() => {
    if (product) {
      const faqDoc = doc(
        db,
        FIREBASE_COLLECTION,
        process.env.REACT_APP_ACTIVE_ENVIRONMENT,
      )
      const faqRef = collection(faqDoc, SUB_COLLECTION)
      const nestedDocRef = doc(faqRef, product.product_id)

      onSnapshot(nestedDocRef, (doc) => {
        setFaq(doc.data())
      })
    }
  }, [product])

  const getFaq = (productId) => {
    dispatch(tryGetFaqById(productId))
  }

  const onDelete = async (id) => {
    const faqDoc = doc(
      db,
      FIREBASE_COLLECTION,
      process.env.REACT_APP_ACTIVE_ENVIRONMENT,
    )
    const faqRef = collection(faqDoc, SUB_COLLECTION)
    const nestedDocRef = doc(faqRef, product.product_id)
    const payload = {
      ...faq,
      faq: faq.faq.filter((f) => f.id !== id),
    }
    await updateDoc(nestedDocRef, payload)
  }

  return (
    <>
      <CustomCard>
        <CustomCardHeader contentPosition="none">
          <div className="flex items-center justify-between w-full">
            <h2 className="text-2xl text-white">Product FAQs</h2>
            {isLogged && (
              <SemiTransparentButton
                onClick={() => {
                  signOut(auth)
                  toast.success('Logged Out')
                }}
              >
                Log Out
              </SemiTransparentButton>
            )}
          </div>
        </CustomCardHeader>
        <CardBody>
          <div className={`flex justify-center items-center mb-2 mx-auto ${!product && "py-20 flex-col w-2/3"}`}>
            {product ? <div className="text-base mb-4 shrink-0 mr-3">Search for Jeevee Products: </div> :
            <div className={`text-2xl font-bold mb-6`}>Create FAQs for Jeevee Products.</div>
            }
            <ProductSearchSelect
              hasVariant={false}
              onChange={(v) => {
                getFaq(v.product_id)
                setProduct(v)
              }}
              value={product}

            />
          </div>
        </CardBody>
        {loading ? (
          <ComponentLoader />
        ) : (
          <div className='flex items-start space-x-4'>
            {product && (
              <div className="mb-2 web sticky top-4 space-y-4">
                <ProductCard product={product} hideButton={true}/>
                {faq?.faq?.length > 0 && <CustomButton onClick={() => setShowModal(product)} className="w-full justify-center">
                  + Add New FAQ
                </CustomButton>}

              </div>
            )}
            <div className="flex flex-col">
              {faq?.faq?.map((f, index) => (

                  <FaqCard
                    faq={f}
                    key={`faq-${index}`}
                    setRemoveModal={setRemoveModal}
                    productId={faq.product_id}
                    isEdit={isEdit}
                    setEdit={setEdit}
                    open={() => expanded === index ? setExpanded(undefined): setExpanded(index) }
                    isExpanded={expanded === index}
                  />

              ))}

            </div>
            {product && (
             <>
             {faq?.faq?.length > 0 ?
                <>
                </> : <EmptyState message="There are no FAQs for this product." hasBackground={true} hasButton={true} buttonLabel="+ Add FAQs" onClick={() => setShowModal(product)} icon="forum"/>}
             </>
            )}
          </div>
        )}

        <AddFaqForm showModal={showModal} setShowModal={setShowModal} />
        <ConfirmModal
          setShowModal={setRemoveModal}
          showModal={removeModal}
          onConfirm={() => {
            onDelete(removeModal.id)
          }}
          disabled={processing}
          title="Remove FAQ"
          children="Are you sure you want to remove?"
        />
      </CustomCard>
    </>
  )
}

export default ProductFaq

const FaqCard = ({ faq, setRemoveModal, productId, isEdit, setEdit, isExpanded, open }) => {
  // const dispatch = useDispatch()

  const update = async () => {
    const faqDoc = doc(
      db,
      FIREBASE_COLLECTION,
      process.env.REACT_APP_ACTIVE_ENVIRONMENT,
    )
    const faqRef = collection(faqDoc, SUB_COLLECTION)
    const nestedDocRef = doc(faqRef, productId.toString())

    const productFaq = (await getDoc(nestedDocRef)).data()
    await updateDoc(nestedDocRef, {
      faq: productFaq.faq.map((f) => (f.id === isEdit?.id ? isEdit : f)),
    })
    setEdit()
  }

  return !!isEdit && isEdit.id === faq.id ? (
    <div className="flex flex-col custom-card">
      <TextArea
        type="text"
        color="blue"
        rows="2"
        placeholder="Question"
        value={isEdit ? isEdit['question'] : faq['question']}
        onChange={(e) => {
          setEdit((prev) => ({ ...prev, question: e }))
        }}
      />
      <TextEditor
        label="Answer"
        onChange={(e) => {
          setEdit((prev) => ({ ...prev, answer: e }))
        }}
        value={isEdit ? isEdit['answer'] : faq['answer']}
      />

      <div className="flex justify-end mt-4">
        <SecondaryButton
          onClick={() => {
            setEdit(false)
          }}
        >
          Cancel
        </SecondaryButton>
        <div className="w-5"></div>
        <CustomButton
          onClick={() => {
            update()
          }}
        >
          Save
        </CustomButton>
      </div>
    </div>
  ) : (
    <div className="flex flex-col space-y-1 flex-wrap custom-card pd-0">
      <div className="flex justify-between cursor-pointer p-3.5"  onClick={open}>
        <div className="text-lg font-bold">{faq.question}</div>
          <div className="flex items-center space-x-2">
            <CustomButton
              isIconButton={true}
              onClick={(e) => {
                e.stopPropagation();
                setEdit(faq)
              }}
            >
              <CustomIcon icon="edit" />
            </CustomButton>
            <DangerButton isIconButton={true} onClick={(e) => {
              e.stopPropagation();
              setRemoveModal(faq)
            }}>
              <CustomIcon icon="delete" />
            </DangerButton>
            <CustomIcon icon="expand_more" size="2xl" className={`pl-2.3 transition-transform${isExpanded ? ' rotate-180' : ''}`}/>
          </div>
      </div>
      <div
        className={`transition-all ${isExpanded ? 'max-h-[9999px] opacity-100 p-3.5' : 'max-h-0 opacity-0 overflow-hidden'}`}>

        <div
          className="edited-text"
          dangerouslySetInnerHTML={{ __html: faq.answer }}
        />
      </div>
    </div>
  )
}
